import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import chineseData from '../data/chineseData';
import TextToSpeech from './TextToSpeech';
import PinyinInput from './PinyinInput';
import { useLevelUnit } from '../context/LevelUnitContext'; // Import context hook

const PinyinQuiz = () => {
  const [current, setCurrent] = useState(0);
  const [userInput, setUserInput] = useState('');
  const [message, setMessage] = useState('');
  const [color, setColor] = useState('');

  const { level, unit, isRandom } = useLevelUnit(); // Destructure the context values

  const words = chineseData.filter(item => item.pinyin_number.length > 0);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setUserInput(value);
    if (value.match(/^[1-9]+$/)) {
      if (value === words[current].pinyin_number) {
        setMessage('Correct');
        setColor('green');
        nextQuiz();
      } else if (value.length === words[current].pinyin_number.length) {
        setMessage('Wrong');
        setColor('red');
        setTimeout(() => {
          setUserInput('');
          setMessage('');
        }, 1000);
      }
    }
  };

  const getFilteredData = () => {
    return words.filter(item => {
      return (!level || item.Level === level) && 
             (!unit || item.Unit === unit)
    });
  };

  const nextQuiz = () => {
    setTimeout(() => {
      if (isRandom) {
        const filteredData = getFilteredData();
        const randomIndex = Math.floor(Math.random() * filteredData.length);
        setCurrent(words.indexOf(filteredData[randomIndex]));
      } else {
        setCurrent(prev => (prev + 1) % words.length);
      }
      setUserInput('');
      setMessage('');
    }, 1000);
  };

  // On component mount or context change, reset quiz
  useEffect(() => {
    const filteredData = getFilteredData();
    const initialQuizIndex = isRandom ? Math.floor(Math.random() * filteredData.length) : 0;
    setCurrent(words.indexOf(filteredData[initialQuizIndex]));
  }, [level, unit, isRandom]); // Dependency array includes context values

  return (
    <Box sx={{
      maxWidth: '600px',
      width: '90%',
      margin: 'auto',
      textAlign: 'center',
      padding: 2,
      minHeight: '300px',
    }}>
      <TextToSpeech text={words[current].簡体字} />
      <Typography variant="h5" component="p" sx={{ marginY: 2 }}>
        {words[current].簡体字}
      </Typography>
      <PinyinInput userInput={userInput} setUserInput={setUserInput} onInputChange={handleInputChange} />
      <Typography color={color} sx={{ marginTop: 1 }}>{message}</Typography>
    </Box>
  );
};

export default PinyinQuiz;
